window.addEventListener("load", () => {
  // Keyframes scroll trigger – add .in-view when element enters viewport
  const animated = document.querySelectorAll(".animate-on-scroll, .animate-fade-in, .animate-slide-left, .animate-slide-right, .animate-zoom-in");
  if (animated.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in-view");
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -50px 0px" }
    );
    animated.forEach((el) => io.observe(el));
  }
});

document.querySelectorAll('a[href="#"]').forEach((link) => {
  link.addEventListener("click", (e) => e.preventDefault());
});



// Smooth scroll for anchor links without updating the URL hash
// Select all anchor links that start with # but are not just '#'
document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((link) => {
  link.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href").slice(1);
    const target = document.getElementById(targetId);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
      // Do not update the URL hash
      // Optionally, you can manage focus for accessibility:
      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
    }
  });
});

